import { render, staticRenderFns } from "./antenataltreatment.vue?vue&type=template&id=9f9ccb32"
import script from "./antenataltreatment.vue?vue&type=script&lang=js"
export * from "./antenataltreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports